// Usually this will be scripts Gravity forms or Contact form 7 WordPress plugins.

const labelContainer = document.querySelectorAll(".label-container");
const inputBoxes = document.querySelectorAll(".form-control");
const labels = document.querySelectorAll(".formlabel");

inputBoxes.forEach(box => {
    const boxLabel = box.parentElement.parentElement.querySelector(".formlabel")
    box.addEventListener("focusin", (e) => {
        if (box === document.activeElement) {
            boxLabel.classList.add("focused");
        } else if (box === document.activeElement) {
            boxLabel.classList.remove("focused");
        }
    })
    box.addEventListener("focusout", () => {
        if (box.value === "") {
            boxLabel.classList.remove("focused");
        }

    })
})

const textarea = document.querySelector("#message");

if (textarea) {
    textarea.addEventListener('input', autoResize, false);

    function autoResize() {
        this.style.height = 'auto';
        this.style.height = this.scrollHeight + 'px';
    }
}

// show thank you message after message is sent

const formContainer = document.querySelector(".wpcf7");
const form = formContainer?.querySelector("form");
const thankYouMessage = document.querySelector(".thank-you-message");
const title = document.querySelector(".register .container");
if (formContainer && form.id !== "login-form") {
    document.addEventListener('wpcf7mailsent', function (event) {
        formContainer.style.opacity = 0;
        window.scrollTo(0, 0);
        setTimeout(() => {
            formContainer.style.display = "none";
            thankYouMessage.style.display = "flex";
            setTimeout(() => {
                thankYouMessage.style.opacity = 1;
                let titleHeight = title.offsetHeight;
                thankYouMessage.style.height = `calc(100svh - ${titleHeight}px`;
            }, 10)

        }, 200)
    }, false);
}
